import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const StoreSolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.9 5.6L17.9 0.6C17.8 0.2 17.4 0 17 0H3C2.6 0 2.2 0.2 2.1 0.6L0.0999999 5.6C-9.68575e-08 5.7 0 5.9 0 6C0 7.4 0.8 8.7 2 9.4V19C2 19.6 2.4 20 3 20H17C17.6 20 18 19.6 18 19V9.4C19.2 8.7 20 7.4 20 6C20 5.9 20 5.7 19.9 5.6ZM16 18H13V13C13 12.4 12.6 12 12 12H8C7.4 12 7 12.4 7 13V18H4V10C5.2 10 6.2 9.5 7 8.6C8.4 10.3 10.9 10.5 12.6 9C12.8 8.9 12.9 8.7 13 8.6C13.8 9.5 14.8 10 16 10V18Z"
      fill={color}
    />
  </svg>
)

StoreSolidSvg.defaultProps = {
  width: 20,
  height: 20,
  color: colors.Primary.GreyText
}

export default StoreSolidSvg
